import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { UpdateCnFInventoryScheama } from "../../../Schemas/Farm support/cnf_inventory_schema.js";
import { UpdateFarmerInventoryScheama } from "../../../Schemas/Farm support/farmer_inventory_schema.js";
import { IventoryPlantInfoUpdate } from "../../../SchemaInfo/info.js";
import { Formik, Form } from "formik";
import performRequest from "../../../api/request.js";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response.js";
import { Toast } from "../../../CustomComponent/toast.js";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton.jsx";
import CustomInput from "../../../CustomComponent/custom_input.js";

const CnFPlantInventoryView = () => {
  const [data, setData] = useState();
  const [refresh, setRefresh] = useState(false);
  let { id } = useParams();
  const [IventoryPlantInfo, setIventoryPlantInfo] = useState(
    IventoryPlantInfoUpdate
  );
  const navigate = useNavigate();
  useEffect(() => {
    performRequest("GET", `/pmg/cf-inventorys/cf-inventorys/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [id, refresh]);

  useEffect(() => {
    performRequest("GET", `/pmg/cf-inventorys/cf-inventorys/${id}`)
      .then((res) => {
        if (res.status === 200) {
          let obj = {
            quantity: res.data.quantity,
          };
          setIventoryPlantInfo(obj);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [id]);

  // const handelSubmit = (values) => {
  //   setRefresh(true);
  //   performRequest(
  //     "PATCH",
  //     `/pmg/cf-inventorys/update-cf-inventorys/${id}`,
  //     values
  //   )
  //     .then((res) => {
  //       if (res.status === 200) {
  //         Toast("success", "Updated sucessfully!");
  //         navigate("/farm-cnf-inventory");
  //       } else {
  //         Toast("error", "Error while getting data!");
  //       }
  //       setRefresh(false);
  //     })

  //     .catch((err) => {
  //       CustomErrorResponse(err);
  //     });
  // };


  return (
    <>
      <div className="page-body">
        <div className="container-xl">
          {data?.category === "plant" ? (
            <div className="row row-cards row-deck">
              <div className="col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="">
                      <div className="me-3">
                        <img
                          alt={data?.pmg_plant?.agronomyWikiUpdate?.image}
                          src={`${data?.pmg_plant?.agronomyWikiUpdate?.image}`}
                          style={{ height: "200px", width: "250px" }}
                        ></img>
                      </div>
                      <div className="mt-3 ">
                        <span className="fs-3">
                          <b>Plant SKU : </b>
                        </span>
                        <span className="fs-4">
                          &nbsp;{data?.pmg_plant?.plantSKU}
                        </span>
                      </div>
                      <div className="mt-1">
                        <span className="fs-3">
                          <b>Article Type : </b>
                        </span>
                        <span className="fs-4">
                          &nbsp;
                          {data?.pmg_plant?.agronomyWikiUpdate?.articleType}
                        </span>
                      </div>
                      <div className="mt-1">
                        <span className="fs-3">
                          <b>Sub Category : </b>
                        </span>
                        <span className="fs-4">
                          &nbsp;
                          {data?.pmg_plant?.agronomyWikiUpdate?.subCategory}
                        </span>
                      </div>
                      <div className="mt-1">
                        <span className="fs-3">
                          <b>Scientific Name : </b>
                        </span>
                        <span className="fs-4">
                          &nbsp;
                          {data?.pmg_plant?.agronomyWikiUpdate?.scientificName}
                        </span>
                      </div>
                      <div className="mt-1">
                        <span className="fs-3">
                          <b>Quantity </b>
                        </span>
                        <span className="fs-4">
                          &nbsp;
                          {data?.quantity}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="card card-lg">
                  <div className="card-body">
                    <div className="markdown">
                      <h1>{data?.pmg_plant?.agronomyWikiUpdate?.name}</h1>
                      <p>{data?.pmg_plant?.agronomyWikiUpdate?.description}</p>
                    </div>
                    <div>
                      {/* <div className="btn-list mt-5">
                        <span
                          data-bs-toggle="modal"
                          data-bs-target="#modal-update"
                        >
                          <button className="btn btn-primary">Update</button>
                        </span>
                      </div> */}
                      <div
                        className="modal modal-blur fade"
                        id="modal-update"
                        tabIndex="-1"
                        role="dialog"
                        aria-hidden="true"
                      >
                        <Formik
                          initialValues={IventoryPlantInfo}
                          validationSchema={UpdateFarmerInventoryScheama}
                          // onSubmit={handelSubmit}
                          enableReinitialize
                        >
                          {(props) => (
                            <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100 ">
                              <div
                                className="modal-dialog modal-dialog-centered w-100"
                                role="document"
                              >
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5 className="modal-title">
                                      Update inventory
                                    </h5>
                                    <button
                                      type="button"
                                      className="btn-close"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                    ></button>
                                  </div>
                                  <div className="modal-body">
                                    {/* <div className="mb-3 row ">
                    <label className="form-label required">
                      Select Plant
                    </label>
                    <div className="w-100 col">
                      <CustomSelect
                        name="plantId"
                        type="text"
                        className="form-control disabled"
                      >
                        <option value="">Select</option>
                        {Plants?.map((item) => (
                          <option value={item?.id}>{item?.plantSKU}</option>
                        ))}
                      </CustomSelect>
                      {props.touched.plantId && props.errors.plantId&& (
                        <p className="text-danger">
                          {props.errors.plantId}
                        </p>
                      )}
                    </div>
                  </div> */}
                                    <div className="mb-3 row">
                                      <label className="form-label required">
                                        Quantity
                                      </label>
                                      <div className="w-100 col">
                                        <CustomInput
                                          name="quantity"
                                          type="text"
                                        />
                                        {props.touched.quantity &&
                                          props.errors.quantity && (
                                            <p className="text-danger">
                                              {props.errors.quantity}
                                            </p>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer bg-transparent">
                                    <button
                                      type="button"
                                      className="btn me-auto disable"
                                      data-bs-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                    <div className="btn-list justify-content-center">
                                      <FormSubmitButton
                                        buttonText={"Update Item"}
                                        data-bs-dismiss="modal"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            //////////////////
            <div className="row row-cards row-deck">
              <div className="col-lg-3">
                <div className="card">
                  <div className="card-body">
                    <div className="">
                      <div className="me-3">
                        <img
                          alt={data?.pmg_accessory?.photo}
                          src={`${data?.pmg_accessory?.photo}`}
                          style={{ height: "200px", width: "250px" }}
                        ></img>
                      </div>
                      <div className="mt-3 ">
                        <span className="fs-3">
                          <b>Acc SKU : </b>
                        </span>
                        <span className="fs-4">
                          &nbsp;{data?.pmg_accessory?.accSKU}
                        </span>
                      </div>
                      <div className="mt-1">
                        <span className="fs-3">
                          <b>Quantity : </b>
                        </span>
                        <span className="fs-4">
                          &nbsp;
                          {data?.quantity}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="card card-lg">
                  <div className="card-body">
                    <div className="markdown">
                      <h1>{data?.pmg_accessory?.name}</h1>
                      <p>{data?.pmg_accessory?.description}</p>
                    </div>
                    <div>
                      <div className="btn-list mt-5">
                        {/* <span
                          data-bs-toggle="modal"
                          data-bs-target="#modal-update"
                        >
                          <button className="btn btn-primary">Update</button>
                        </span> */}
                      </div>
                      <div
                        className="modal modal-blur fade"
                        id="modal-update"
                        tabIndex="-1"
                        role="dialog"
                        aria-hidden="true"
                      >
                        <Formik
                          initialValues={IventoryPlantInfo}
                          validationSchema={UpdateCnFInventoryScheama}
                          // onSubmit={handelSubmit}
                          enableReinitialize
                        >
                          {(props) => (
                            <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100 ">
                              <div
                                className="modal-dialog modal-dialog-centered w-100"
                                role="document"
                              >
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5 className="modal-title">
                                      Update inventory
                                    </h5>
                                    <button
                                      type="button"
                                      className="btn-close"
                                      data-bs-dismiss="modal"
                                      aria-label="Close"
                                    ></button>
                                  </div>
                                  <div className="modal-body">
                                    <div className="mb-3 row">
                                      <label className="form-label required">
                                        Quantity
                                      </label>
                                      <div className="w-100 col">
                                        <CustomInput
                                          name="quantity"
                                          type="text"
                                        />
                                        {props.touched.quantity &&
                                          props.errors.quantity && (
                                            <p className="text-danger">
                                              {props.errors.quantity}
                                            </p>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      className="btn me-auto disable"
                                      data-bs-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                    <div className="card-footer bg-transparent mt-auto">
                                      <div className="btn-list justify-content-center">
                                        <FormSubmitButton
                                          buttonText={"Update Item"}
                                          data-bs-dismiss="modal"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CnFPlantInventoryView;
